import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=7b9e4574"
import script from "./dispatch.vue?vue&type=script&lang=js"
export * from "./dispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports